import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import moment from "moment";
import { CRYPTO_SECRET_KEY, PER_PAGE } from "src/_config";
import { useEventApi } from "src/_common/hooks/actions/event/appEventApiHook";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import { useToaster } from "src/_common/hooks/actions/common/appToasterHook";

const Cryptr = require("cryptr");
const cryptr = new Cryptr(CRYPTO_SECRET_KEY);

export default function UpcomingRodeoEventComponent() {
  const eventApi = useEventApi();
  const toast = useToaster();

  const [eventListData, setEventListData] = useState<any[]>([]);
  const [page, setPage] = useState<number>(1);
  const { eventId } = useParams<any>();
  const e_id: number = parseInt(cryptr.decrypt(eventId));
  const [galleryData, setGalleryData] = useState<any[]>([]);

  const options = {
    items: 1, // Display only one item at a time
    // margin: 10,
    nav: true, // Enable navigation arrows
    dots: true, // Enable dots for navigation
    autoplay: true, // Automatically transition between slides
    loop: true, // Loop the carousel
  };

  const getGallery = () => {
    eventApi.callGetGallery(
      { rodeo_event_id: e_id },
      (message: string, resp: any) => {
        if (resp?.data) {
          console.log(resp);
          setGalleryData(resp.data);
        }
      },
      (message: string) => {
        toast.error(message);
      }
    );
  };

  useEffect(() => {
    getGallery();
  }, []);

  return (
    <>
      {galleryData?.length > 0 ? (
        <>
          <h1>Upcoming</h1>
          <div className="gallery-slider-panel mb-3">
            <OwlCarousel {...options}>
              {galleryData.map((item: any, index: number) => (
                <div key={index} className="banner">
                  <img src={item?.image?.original} />
                </div>
              ))}
            </OwlCarousel>
          </div>
        </>
      ) : null}
    </>
  );
}
